import {
  GET_ALL_RESTAURANT_CATEGORY_LIST_REQUEST,
  GET_ALL_RESTAURANT_CATEGORY_LIST_SUCCESS,
  GET_ALL_RESTAURANT_CATEGORY_LIST_FAILURE,
  POST_RESTAURANT_CATEGORY_REQUEST,
  POST_RESTAURANT_CATEGORY_SUCCESS,
  POST_RESTAURANT_CATEGORY_FAILURE,
  PUT_RESTAURANT_CATEGORY_REQUEST,
  PUT_RESTAURANT_CATEGORY_SUCCESS,
  PUT_RESTAURANT_CATEGORY_FAILURE,
  DELETE_RESTAURANT_CATEGORY_REQUEST,
  DELETE_RESTAURANT_CATEGORY_SUCCESS,
  DELETE_RESTAURANT_CATEGORY_FAILURE,
  GET_ALL_RESTAURANT_SUB_CATEGORY_LIST_REQUEST,
  GET_ALL_RESTAURANT_SUB_CATEGORY_LIST_SUCCESS,
  GET_ALL_RESTAURANT_SUB_CATEGORY_LIST_FAILURE,
  POST_RESTAURANT_SUB_CATEGORY_REQUEST,
  POST_RESTAURANT_SUB_CATEGORY_SUCCESS,
  POST_RESTAURANT_SUB_CATEGORY_FAILURE,
  PUT_RESTAURANT_SUB_CATEGORY_REQUEST,
  PUT_RESTAURANT_SUB_CATEGORY_SUCCESS,
  PUT_RESTAURANT_SUB_CATEGORY_FAILURE,
  DELETE_RESTAURANT_SUB_CATEGORY_REQUEST,
  DELETE_RESTAURANT_SUB_CATEGORY_SUCCESS,
  DELETE_RESTAURANT_SUB_CATEGORY_FAILURE,
  GET_ALL_RESTAURANT_VARIANT_LIST_REQUEST,
  GET_ALL_RESTAURANT_VARIANT_LIST_SUCCESS,
  GET_ALL_RESTAURANT_VARIANT_LIST_FAILURE,
  POST_RESTAURANT_VARIANT_REQUEST,
  POST_RESTAURANT_VARIANT_SUCCESS,
  POST_RESTAURANT_VARIANT_FAILURE,
  PUT_RESTAURANT_VARIANT_REQUEST,
  PUT_RESTAURANT_VARIANT_SUCCESS,
  PUT_RESTAURANT_VARIANT_FAILURE,
  DELETE_RESTAURANT_VARIANT_REQUEST,
  DELETE_RESTAURANT_VARIANT_SUCCESS,
} from "../../../Utils/Constant";

const initialState = {
  categoryList: {},
  addCategory: {},
  updateCategory: {},
  deleteCategory: {},
  loading: false,
  error: null,
  subCategoryList:{},
  addSubCategory:{},
  updateSubCategory:{},
  deleteSubCategory:{},
  varientList:{},
  addVarient:{},
  updateVarient:{},
  deleteVarient:{}
};

export const restaurantReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_RESTAURANT_CATEGORY_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_ALL_RESTAURANT_CATEGORY_LIST_SUCCESS:
      return {
        ...state,
        categoryList: action.payload,
        loading: false,
        error: null,
      };
    case GET_ALL_RESTAURANT_CATEGORY_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case POST_RESTAURANT_CATEGORY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case POST_RESTAURANT_CATEGORY_SUCCESS:
      return {
        ...state,
        addCategory: action.payload,
        loading: false,
        error: null,
      };

    case POST_RESTAURANT_CATEGORY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case PUT_RESTAURANT_CATEGORY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case PUT_RESTAURANT_CATEGORY_SUCCESS:
      return {
        ...state,
        updateCategory: action.payload,
        loading: false,
        error: null,
      };

    case PUT_RESTAURANT_CATEGORY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_RESTAURANT_CATEGORY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case DELETE_RESTAURANT_CATEGORY_SUCCESS:
      return {
        ...state,
        deleteCategory: action.payload,
        loading: false,
        error: null,
      };

    case DELETE_RESTAURANT_CATEGORY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // SUB CATEGORY REDUCERS //

    case GET_ALL_RESTAURANT_SUB_CATEGORY_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_ALL_RESTAURANT_SUB_CATEGORY_LIST_SUCCESS:
      return {
        ...state,
        subCategoryList: action.payload,
        loading: false,
        error: null,
      };
    case GET_ALL_RESTAURANT_SUB_CATEGORY_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case POST_RESTAURANT_SUB_CATEGORY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case POST_RESTAURANT_SUB_CATEGORY_SUCCESS:
      return {
        ...state,
        addSubCategory: action.payload,
        loading: false,
        error: null,
      };

    case POST_RESTAURANT_SUB_CATEGORY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case PUT_RESTAURANT_SUB_CATEGORY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case PUT_RESTAURANT_SUB_CATEGORY_SUCCESS:
      return {
        ...state,
        updateSubCategory: action.payload,
        loading: false,
        error: null,
      };

    case PUT_RESTAURANT_SUB_CATEGORY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_RESTAURANT_SUB_CATEGORY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case DELETE_RESTAURANT_SUB_CATEGORY_SUCCESS:
      return {
        ...state,
        deleteSubCategory: action.payload,
        loading: false,
        error: null,
      };

    case DELETE_RESTAURANT_SUB_CATEGORY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case GET_ALL_RESTAURANT_VARIANT_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_ALL_RESTAURANT_VARIANT_LIST_SUCCESS:
      return {
        ...state,
        varientList: action.payload,
        loading: false,
        error: null,
      };
    case GET_ALL_RESTAURANT_VARIANT_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case POST_RESTAURANT_VARIANT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case POST_RESTAURANT_VARIANT_SUCCESS:
      return {
        ...state,
        addVarient: action.payload,
        loading: false,
        error: null,
      };

    case POST_RESTAURANT_VARIANT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case PUT_RESTAURANT_VARIANT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case PUT_RESTAURANT_VARIANT_SUCCESS:
      return {
        ...state,
        updateVarient: action.payload,
        loading: false,
        error: null,
      };

    case PUT_RESTAURANT_VARIANT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_RESTAURANT_VARIANT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case DELETE_RESTAURANT_VARIANT_SUCCESS:
      return {
        ...state,
        deleteVarient: action.payload,
        loading: false,
        error: null,
      };

    case DELETE_RESTAURANT_SUB_CATEGORY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};
